import _ from 'lodash';

export default {
  setActiveReportColumns: (store, columns) => {
    const preparedColumnSettings = columns.reduce((acc, column) => {

      const { columns, width, totalType } = column.columns.reduce((acc, { name, width,totalType }) => {
        acc.columns.push(name);
        acc.width[name] = width
        if(totalType){
          acc.totalType[name] = totalType 
        }

        return acc
      }, { columns: [], width: {}, totalType: {} })

      acc[column.context] = {
        ...column,
        columns,
        width,
        totalType,
      }

      return acc
    }, _.cloneDeep(store.getters.getDefaultColumns))

    store.commit('setActiveReportColumns', { columns: preparedColumnSettings })
  },
};
